// extracted by mini-css-extract-plugin
export var MigrationNoticeBanner = "MigrationNoticeBanner-module--MigrationNoticeBanner---hLDJ";
export var MigrationNoticeBanner_container = "MigrationNoticeBanner-module--MigrationNoticeBanner_container--9w-7e";
export var MigrationNoticeBanner_message = "MigrationNoticeBanner-module--MigrationNoticeBanner_message--kDnKR";
export var container = "MigrationNoticeBanner-module--container--vvTHu";
export var gatsbyImageWrapperConstrained = "MigrationNoticeBanner-module--gatsby-image-wrapper-constrained--DJ75x";
export var gridSpan1010 = "MigrationNoticeBanner-module--grid-span-10-10--1JFNP";
export var gridSpan1011 = "MigrationNoticeBanner-module--grid-span-10-11--aaZAz";
export var gridSpan102 = "MigrationNoticeBanner-module--grid-span-10-2--dQov8";
export var gridSpan103 = "MigrationNoticeBanner-module--grid-span-10-3--n0Ceb";
export var gridSpan104 = "MigrationNoticeBanner-module--grid-span-10-4--DMCTe";
export var gridSpan105 = "MigrationNoticeBanner-module--grid-span-10-5--9hQOq";
export var gridSpan106 = "MigrationNoticeBanner-module--grid-span-10-6--PsS30";
export var gridSpan107 = "MigrationNoticeBanner-module--grid-span-10-7--aPFyz";
export var gridSpan108 = "MigrationNoticeBanner-module--grid-span-10-8--7BEUv";
export var gridSpan109 = "MigrationNoticeBanner-module--grid-span-10-9--jRF1u";
export var gridSpan110 = "MigrationNoticeBanner-module--grid-span-1-10--E78oS";
export var gridSpan111 = "MigrationNoticeBanner-module--grid-span-1-11--mVPqt";
export var gridSpan1110 = "MigrationNoticeBanner-module--grid-span-11-10--r0zfB";
export var gridSpan1111 = "MigrationNoticeBanner-module--grid-span-11-11--tEz-c";
export var gridSpan112 = "MigrationNoticeBanner-module--grid-span-11-2--mz8ji";
export var gridSpan113 = "MigrationNoticeBanner-module--grid-span-11-3--Tdhmx";
export var gridSpan114 = "MigrationNoticeBanner-module--grid-span-11-4--088Hv";
export var gridSpan115 = "MigrationNoticeBanner-module--grid-span-11-5--6rPhH";
export var gridSpan116 = "MigrationNoticeBanner-module--grid-span-11-6--jBZQv";
export var gridSpan117 = "MigrationNoticeBanner-module--grid-span-11-7--JPLwA";
export var gridSpan118 = "MigrationNoticeBanner-module--grid-span-11-8--Xqs0Z";
export var gridSpan119 = "MigrationNoticeBanner-module--grid-span-11-9--6JyQT";
export var gridSpan12 = "MigrationNoticeBanner-module--grid-span-1-2--IUr0v";
export var gridSpan1210 = "MigrationNoticeBanner-module--grid-span-12-10--OFZEt";
export var gridSpan1211 = "MigrationNoticeBanner-module--grid-span-12-11--RGe8Z";
export var gridSpan122 = "MigrationNoticeBanner-module--grid-span-12-2--oXVk7";
export var gridSpan123 = "MigrationNoticeBanner-module--grid-span-12-3--fwWnb";
export var gridSpan124 = "MigrationNoticeBanner-module--grid-span-12-4--ZlAba";
export var gridSpan125 = "MigrationNoticeBanner-module--grid-span-12-5--T2Vpf";
export var gridSpan126 = "MigrationNoticeBanner-module--grid-span-12-6--aSSJs";
export var gridSpan127 = "MigrationNoticeBanner-module--grid-span-12-7--X2Gtr";
export var gridSpan128 = "MigrationNoticeBanner-module--grid-span-12-8--YLNj-";
export var gridSpan129 = "MigrationNoticeBanner-module--grid-span-12-9--cOxja";
export var gridSpan13 = "MigrationNoticeBanner-module--grid-span-1-3--c8QHU";
export var gridSpan14 = "MigrationNoticeBanner-module--grid-span-1-4--VnZ7r";
export var gridSpan15 = "MigrationNoticeBanner-module--grid-span-1-5--z6hS4";
export var gridSpan16 = "MigrationNoticeBanner-module--grid-span-1-6--iQuIE";
export var gridSpan17 = "MigrationNoticeBanner-module--grid-span-1-7--nkpcm";
export var gridSpan18 = "MigrationNoticeBanner-module--grid-span-1-8--5NGYr";
export var gridSpan19 = "MigrationNoticeBanner-module--grid-span-1-9--xQKd8";
export var gridSpan210 = "MigrationNoticeBanner-module--grid-span-2-10--MwaRq";
export var gridSpan211 = "MigrationNoticeBanner-module--grid-span-2-11--Y5cKr";
export var gridSpan22 = "MigrationNoticeBanner-module--grid-span-2-2--98bPo";
export var gridSpan23 = "MigrationNoticeBanner-module--grid-span-2-3--Hspql";
export var gridSpan24 = "MigrationNoticeBanner-module--grid-span-2-4--1fGld";
export var gridSpan25 = "MigrationNoticeBanner-module--grid-span-2-5--j3Nts";
export var gridSpan26 = "MigrationNoticeBanner-module--grid-span-2-6--UlOqS";
export var gridSpan27 = "MigrationNoticeBanner-module--grid-span-2-7--WaGJi";
export var gridSpan28 = "MigrationNoticeBanner-module--grid-span-2-8--YdBNt";
export var gridSpan29 = "MigrationNoticeBanner-module--grid-span-2-9--mi7mo";
export var gridSpan310 = "MigrationNoticeBanner-module--grid-span-3-10--5Vd-+";
export var gridSpan311 = "MigrationNoticeBanner-module--grid-span-3-11--d3k2a";
export var gridSpan32 = "MigrationNoticeBanner-module--grid-span-3-2--JX-CF";
export var gridSpan33 = "MigrationNoticeBanner-module--grid-span-3-3--5wfDB";
export var gridSpan34 = "MigrationNoticeBanner-module--grid-span-3-4--T1P5d";
export var gridSpan35 = "MigrationNoticeBanner-module--grid-span-3-5--AoqPW";
export var gridSpan36 = "MigrationNoticeBanner-module--grid-span-3-6--9dwCd";
export var gridSpan37 = "MigrationNoticeBanner-module--grid-span-3-7--yfkpE";
export var gridSpan38 = "MigrationNoticeBanner-module--grid-span-3-8--LKi+J";
export var gridSpan39 = "MigrationNoticeBanner-module--grid-span-3-9--ISO75";
export var gridSpan410 = "MigrationNoticeBanner-module--grid-span-4-10--LiCFs";
export var gridSpan411 = "MigrationNoticeBanner-module--grid-span-4-11--ZG0sq";
export var gridSpan42 = "MigrationNoticeBanner-module--grid-span-4-2--Hgg97";
export var gridSpan43 = "MigrationNoticeBanner-module--grid-span-4-3--hqws4";
export var gridSpan44 = "MigrationNoticeBanner-module--grid-span-4-4--WlJsu";
export var gridSpan45 = "MigrationNoticeBanner-module--grid-span-4-5--fvMJF";
export var gridSpan46 = "MigrationNoticeBanner-module--grid-span-4-6--lRWR3";
export var gridSpan47 = "MigrationNoticeBanner-module--grid-span-4-7--8rT8K";
export var gridSpan48 = "MigrationNoticeBanner-module--grid-span-4-8--Z2FnN";
export var gridSpan49 = "MigrationNoticeBanner-module--grid-span-4-9--mXyp4";
export var gridSpan510 = "MigrationNoticeBanner-module--grid-span-5-10--HV93r";
export var gridSpan511 = "MigrationNoticeBanner-module--grid-span-5-11--XTsIc";
export var gridSpan52 = "MigrationNoticeBanner-module--grid-span-5-2--+hJA4";
export var gridSpan53 = "MigrationNoticeBanner-module--grid-span-5-3--VvJ3G";
export var gridSpan54 = "MigrationNoticeBanner-module--grid-span-5-4--Gbu6K";
export var gridSpan55 = "MigrationNoticeBanner-module--grid-span-5-5--gk57a";
export var gridSpan56 = "MigrationNoticeBanner-module--grid-span-5-6--eKNYf";
export var gridSpan57 = "MigrationNoticeBanner-module--grid-span-5-7--ENQRD";
export var gridSpan58 = "MigrationNoticeBanner-module--grid-span-5-8--sA6On";
export var gridSpan59 = "MigrationNoticeBanner-module--grid-span-5-9--dyxx8";
export var gridSpan610 = "MigrationNoticeBanner-module--grid-span-6-10--z05hi";
export var gridSpan611 = "MigrationNoticeBanner-module--grid-span-6-11--bSMGL";
export var gridSpan62 = "MigrationNoticeBanner-module--grid-span-6-2--mClQc";
export var gridSpan63 = "MigrationNoticeBanner-module--grid-span-6-3--2UFDx";
export var gridSpan64 = "MigrationNoticeBanner-module--grid-span-6-4--qHHNx";
export var gridSpan65 = "MigrationNoticeBanner-module--grid-span-6-5--cQqMN";
export var gridSpan66 = "MigrationNoticeBanner-module--grid-span-6-6--tX5uO";
export var gridSpan67 = "MigrationNoticeBanner-module--grid-span-6-7--7EVlk";
export var gridSpan68 = "MigrationNoticeBanner-module--grid-span-6-8--OChxg";
export var gridSpan69 = "MigrationNoticeBanner-module--grid-span-6-9--j1nsV";
export var gridSpan710 = "MigrationNoticeBanner-module--grid-span-7-10--Lg7k3";
export var gridSpan711 = "MigrationNoticeBanner-module--grid-span-7-11--8BN6Q";
export var gridSpan72 = "MigrationNoticeBanner-module--grid-span-7-2--ZvTrP";
export var gridSpan73 = "MigrationNoticeBanner-module--grid-span-7-3--fLKx3";
export var gridSpan74 = "MigrationNoticeBanner-module--grid-span-7-4--GF9li";
export var gridSpan75 = "MigrationNoticeBanner-module--grid-span-7-5--UAiwO";
export var gridSpan76 = "MigrationNoticeBanner-module--grid-span-7-6--PbTcE";
export var gridSpan77 = "MigrationNoticeBanner-module--grid-span-7-7--cJhzj";
export var gridSpan78 = "MigrationNoticeBanner-module--grid-span-7-8--SZ8NF";
export var gridSpan79 = "MigrationNoticeBanner-module--grid-span-7-9--YNQk9";
export var gridSpan810 = "MigrationNoticeBanner-module--grid-span-8-10--P60FC";
export var gridSpan811 = "MigrationNoticeBanner-module--grid-span-8-11--72o5t";
export var gridSpan82 = "MigrationNoticeBanner-module--grid-span-8-2--Ofg8N";
export var gridSpan83 = "MigrationNoticeBanner-module--grid-span-8-3--FnJA+";
export var gridSpan84 = "MigrationNoticeBanner-module--grid-span-8-4--aSG9H";
export var gridSpan85 = "MigrationNoticeBanner-module--grid-span-8-5--EvNqN";
export var gridSpan86 = "MigrationNoticeBanner-module--grid-span-8-6--B22+m";
export var gridSpan87 = "MigrationNoticeBanner-module--grid-span-8-7--RFyvB";
export var gridSpan88 = "MigrationNoticeBanner-module--grid-span-8-8--T3p6D";
export var gridSpan89 = "MigrationNoticeBanner-module--grid-span-8-9--hgyB8";
export var gridSpan910 = "MigrationNoticeBanner-module--grid-span-9-10--XCAbQ";
export var gridSpan911 = "MigrationNoticeBanner-module--grid-span-9-11--GuTxq";
export var gridSpan92 = "MigrationNoticeBanner-module--grid-span-9-2--sP6x1";
export var gridSpan93 = "MigrationNoticeBanner-module--grid-span-9-3--P77UC";
export var gridSpan94 = "MigrationNoticeBanner-module--grid-span-9-4--1JPYw";
export var gridSpan95 = "MigrationNoticeBanner-module--grid-span-9-5--K7p+o";
export var gridSpan96 = "MigrationNoticeBanner-module--grid-span-9-6--jv9Sj";
export var gridSpan97 = "MigrationNoticeBanner-module--grid-span-9-7--ZIymL";
export var gridSpan98 = "MigrationNoticeBanner-module--grid-span-9-8--O3k1a";
export var gridSpan99 = "MigrationNoticeBanner-module--grid-span-9-9--XCVx+";
export var textBreak = "MigrationNoticeBanner-module--text-break--ngdOj";